module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (5).445090f3.jpg";